var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.723,
    height: 38.797,
    viewBox: "0 0 45.723 38.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-call-tv-svgrepo-com",
    transform: "translate(0 -38.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6074",
    "data-name": "Group 6074",
    transform: "translate(0 38.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6073",
    "data-name": "Group 6073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26503",
    "data-name": "Path 26503",
    d: "M138.98,434.238H117.395a1.741,1.741,0,0,0,0,3.481H138.98a1.741,1.741,0,0,0,0-3.481Z",
    transform: "translate(-105.326 -398.922)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26504",
    "data-name": "Path 26504",
    d: "M180.411,141.063h-7.887a1.741,1.741,0,0,0-1.741,1.741v5.45a1.741,1.741,0,0,0,1.741,1.741h7.887a1.741,1.741,0,0,0,1.741-1.741v-1.135l2.131,1.23a1.148,1.148,0,0,0,1.721-.994V143.7a1.148,1.148,0,0,0-1.721-.994l-2.131,1.23V142.8A1.741,1.741,0,0,0,180.411,141.063Z",
    transform: "translate(-155.533 -131.929)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26505",
    "data-name": "Path 26505",
    d: "M44.562,291.385H1.16A1.16,1.16,0,0,0,0,292.546v3.1a5.222,5.222,0,0,0,5.222,5.222H40.5a5.222,5.222,0,0,0,5.222-5.222v-3.1A1.16,1.16,0,0,0,44.562,291.385Z",
    transform: "translate(0 -268.827)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26506",
    "data-name": "Path 26506",
    d: "M40.5,38.777H5.222A5.222,5.222,0,0,0,0,44V56.694a1.16,1.16,0,0,0,1.16,1.16H3.481a1.16,1.16,0,0,0,1.16-1.16V45.16a1.741,1.741,0,0,1,1.741-1.741H39.34a1.741,1.741,0,0,1,1.741,1.741V56.694a1.16,1.16,0,0,0,1.16,1.16h2.321a1.16,1.16,0,0,0,1.16-1.16V44A5.222,5.222,0,0,0,40.5,38.777Z",
    transform: "translate(0 -38.777)",
    fill: "#e5ccd1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.5abaecbdb9fbca07f6f1130a72e6c03f.svg";
export { ForwardRef as ReactComponent };